import styled from 'styled-components';
import { AddCircleOutline as AddIcon } from '@mui/icons-material';

import RoundedButton from '../../../../../../../components/v2/RoundedButton';
import colors from '../../../../../../../styles/colors';
import { ButtonIconStyle } from '../../../../../../../components/v2/Button';
import RadioButtonGroup from '../../../../../../components/RadioButtonGroup';

const StyledButton = styled(RoundedButton)`
  background-color: ${colors.shades.beta2};
  color: ${colors.base.alpha};
`;

const StyledRadioButtonGroup = styled(RadioButtonGroup)`
  margin-bottom: 20px;

  /* Match the feature checkboxes below: FormControlLabel's default -11px margin
     pulls the control flush with the section labels, and the label size is 14px. */
  label {
    margin-left: -11px;
  }
  label .MuiFormControlLabel-label {
    font-size: 14px;
  }
`;

const FeatureContainer = styled.div`
  display: flex;
  flex-direction: column;
  
  .MuiFormControlLabel-label {
    font-size: 14px;
  }
`;

const StyledAddIcon = styled(AddIcon)`
  ${ButtonIconStyle}
  color: ${colors.shades.gamma10};
`;

export {
  StyledButton,
  StyledRadioButtonGroup,
  FeatureContainer,
  StyledAddIcon,
};
